/* global dataLayer */
export function onModelStepView() {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Model',
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onTrimStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Trim',
    modelName: store?.selectedTrim?.modelName || store.selectedModel.modelName,
    year: store?.selectedTrim?.modelYear || store.selectedModel.modelYear,
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onColorStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Colour',
    modelName: store.selectedTrim.modelName,
    year: store.selectedTrim.modelYear,
    trim: store.selectedTrim.trimName,
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onAccessoriesStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Accessories',
    modelName: store.selectedTrim.modelName,
    year: store.selectedTrim.modelYear,
    trim: store.selectedTrim.trimName,
    exteriorColour: store.extColorSelection.colorName_En,
    interiorColour: store?.intColorSelection?.colorName_En?.replace(/[\r\n]+/g, ''),
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onProtectionStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Protection',
    modelName: store.selectedTrim.modelName,
    year: store.selectedTrim.modelYear,
    trim: store.selectedTrim.trimName,
    exteriorColour: store.extColorSelection.colorName_En,
    interiorColour: store?.intColorSelection?.colorName_En?.replace(/[\r\n]+/g, ''),
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onReviewStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Review',
    modelName: store.selectedTrim.modelName,
    year: store.selectedTrim.modelYear,
    trim: store.selectedTrim.trimName,
    exteriorColour: store.extColorSelection.colorName_En,
    interiorColour: store?.intColorSelection?.colorName_En?.replace(/[\r\n]+/g, ''),
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onPaymentStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Payment',
    modelName: store.selectedTrim.modelName,
    year: store.selectedTrim.modelYear,
    trim: store.selectedTrim.trimName,
    exteriorColour: store.extColorSelection.colorName_En,
    interiorColour: store?.intColorSelection?.colorName_En?.replace(/[\r\n]+/g, ''),
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onDeliveryStepView(store) {
  let dataLayerObj = {
    event: 'configurator_load',
    configuratorStep: 'Delivery',
    modelName: store.selectedTrim.modelName,
    year: store.selectedTrim.modelYear,
    trim: store.selectedTrim.trimName,
    exteriorColour: store.extColorSelection.colorName_En,
    interiorColour: store?.intColorSelection?.colorName_En?.replace(/[\r\n]+/g, ''),
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}

export function onBASctaClick(distributor) {
  let dataLayerObj = {
    event: 'schedule_service',
    ctaName: 'Book Now',
    distributor,
  };
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(dataLayerObj);
  } else {
    console.table(dataLayerObj);
  }
}
